import React from 'react';
import { HtmlEmbedView } from './HtmlEmbedView';

const renderNode = (node, index) => {
  switch (node.type) {
    case 'paragraph':
      return (
        <p key={index}>
          {node.content?.map((child, i) => renderNode(child, i))}
        </p>
      );
    case 'heading': {
      const HeadingTag = `h${node.attrs?.level || 2}`;
      return (
        <HeadingTag key={index}>
          {node.content?.map((child, i) => renderNode(child, i))}
        </HeadingTag>
      );
    }
    case 'text': {
      let text = node.text;
      if (node.marks) {
        node.marks.forEach(mark => {
          if (mark.type === 'bold') text = <strong>{text}</strong>;
          if (mark.type === 'italic') text = <em>{text}</em>;
          if (mark.type === 'underline') text = <u>{text}</u>;
          if (mark.type === 'code') text = <code>{text}</code>;
          if (mark.type === 'link') {
            text = <a href={mark.attrs?.href} target="_blank" rel="noopener noreferrer">{text}</a>;
          }
        });
      }
      return <React.Fragment key={index}>{text}</React.Fragment>;
    }
    case 'bulletList':
      return (
        <ul key={index}>
          {node.content?.map((child, i) => renderNode(child, i))}
        </ul>
      );
    case 'orderedList':
      return (
        <ol key={index}>
          {node.content?.map((child, i) => renderNode(child, i))}
        </ol>
      );
    case 'listItem':
      return (
        <li key={index}>
          {node.content?.map((child, i) => renderNode(child, i))}
        </li>
      );
    case 'blockquote':
      return (
        <blockquote key={index}>
          {node.content?.map((child, i) => renderNode(child, i))}
        </blockquote>
      );
    case 'codeBlock':
      return (
        <pre key={index}>
          <code>{node.content?.map(c => c.text).join('')}</code>
        </pre>
      );
    case 'table':
      return (
        <table key={index} className="tiptap-table">
          <tbody>
            {node.content?.map((child, i) => renderNode(child, i))}
          </tbody>
        </table>
      );
    case 'tableRow':
      return (
        <tr key={index}>
          {node.content?.map((child, i) => renderNode(child, i))}
        </tr>
      );
    case 'tableHeader':
      return (
        <th key={index}>
          {node.content?.map((child, i) => renderNode(child, i))}
        </th>
      );
    case 'tableCell':
      return (
        <td key={index}>
          {node.content?.map((child, i) => renderNode(child, i))}
        </td>
      );
    case 'image':
      return (
        <img key={index} src={node.attrs?.src} alt={node.attrs?.alt || ''} />
      );
    case 'htmlEmbed':
      return <HtmlEmbedView key={index} content={node.attrs?.content} />;
    case 'horizontalRule':
      return <hr key={index} />;
    default:
      return null;
  }
};

export const TipTapContentRenderer = ({ content }) => {
  if (!content || !content.content) return null;
  return <>{content.content.map((node, i) => renderNode(node, i))}</>;
};

export default TipTapContentRenderer;
